import "./about.css";
import VisionCard from "./components/VisionCard";
import { ReactComponent as CompanyIcon } from "../assets/icons/company.svg";
import { ReactComponent as ViewIcon } from "../assets/icons/about_view_icon.svg";
import { ReactComponent as MissionIcon } from "../assets/icons/about_mission.svg";
import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";

const OurVision = () => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;
  return (
    <div className="about-vision">
      <VisionCard
        title={t.about.vision.card1.title}
        description={t.about.vision.card1.text}
        Icon={CompanyIcon}
      />
      <div className="covered_section">
        <img src="/imgs/covered_car.png" alt="covered_car" />
      </div>
      <VisionCard
        title={t.about.vision.card2.title}
        description={t.about.vision.card2.text}
        Icon={MissionIcon}
      />
      <VisionCard
        title={t.about.vision.card3.title}
        description={t.about.vision.card3.text}
        Icon={ViewIcon}
      />
    </div>
  );
};

export default OurVision;
